import { investmentsActions } from '../actions';

export default function investments ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case investmentsActions.SET_INVESTMENTS: return generalInvestmentsReducer( newState, action );
        case investmentsActions.GENERAL_INVESTMENTS_REQUEST: return generalInvestmentsReducer( newState, action );
        default: return newState;
    }
}

function generalInvestmentsReducer ( newState, action ) {
    delete action.type;
    return Object.assign( newState, { ...action } );
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/investments.js